/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Auth_TitleInputs */

const en_work_order_publish_auth_title = /** @type {(inputs: Work_Order_Publish_Auth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish Authentication`)
};

const fr_work_order_publish_auth_title = /** @type {(inputs: Work_Order_Publish_Auth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentification de publication`)
};

const de_work_order_publish_auth_title = /** @type {(inputs: Work_Order_Publish_Auth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlichung der Authentifizierung`)
};

const it_work_order_publish_auth_title = /** @type {(inputs: Work_Order_Publish_Auth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pubblica autenticazione`)
};

const ru_work_order_publish_auth_title = /** @type {(inputs: Work_Order_Publish_Auth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Публикация аутентификации`)
};

const es_work_order_publish_auth_title = /** @type {(inputs: Work_Order_Publish_Auth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicar autenticación`)
};

const zh_cn2_work_order_publish_auth_title = /** @type {(inputs: Work_Order_Publish_Auth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布身份验证`)
};

const ja_work_order_publish_auth_title = /** @type {(inputs: Work_Order_Publish_Auth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開認証`)
};

const hi_work_order_publish_auth_title = /** @type {(inputs: Work_Order_Publish_Auth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रकाशन प्रमाणीकरण`)
};

const pt_pt2_work_order_publish_auth_title = /** @type {(inputs: Work_Order_Publish_Auth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicar autenticação`)
};

/**
* | output |
* | --- |
* | "Publish Authentication" |
*
* @param {Work_Order_Publish_Auth_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_auth_title = /** @type {((inputs?: Work_Order_Publish_Auth_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Auth_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_auth_title(inputs)
	if (locale === "de") return de_work_order_publish_auth_title(inputs)
	if (locale === "it") return it_work_order_publish_auth_title(inputs)
	if (locale === "ru") return ru_work_order_publish_auth_title(inputs)
	if (locale === "es") return es_work_order_publish_auth_title(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_auth_title(inputs)
	if (locale === "ja") return ja_work_order_publish_auth_title(inputs)
	if (locale === "hi") return hi_work_order_publish_auth_title(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_auth_title(inputs)
	return en_work_order_publish_auth_title(inputs)
});